/* ---- 用户中心模拟数据 ---- */

export const USER_PROFILE = {
  name: '张三',
  role: '零售客户经理',
  department: '广州分行天河支行',
  joinDate: '2023-06-15',
}

// 用户活动统计
export const USER_ACTIVITY = {
  totalLoginDays: 186,
  thisMonthLoginDays: 22,
  totalReportsCreated: 34,
  totalReportsViewed: 1256,
  totalFavorites: 12,
  totalShares: 8,
  consecutiveLoginDays: 15,
  longestStreak: 45,
}

// 用户月度活动趋势
export const USER_MONTHLY_ACTIVITY = [
  { month: '2026年1月', logins: 18, reportsCreated: 3, reportsViewed: 89 },
  { month: '2026年2月', logins: 16, reportsCreated: 2, reportsViewed: 72 },
  { month: '2026年3月', logins: 20, reportsCreated: 5, reportsViewed: 105 },
  { month: '2026年4月', logins: 19, reportsCreated: 4, reportsViewed: 98 },
  { month: '2026年5月', logins: 22, reportsCreated: 6, reportsViewed: 118 },
  { month: '2026年6月', logins: 21, reportsCreated: 5, reportsViewed: 112 },
]

// 用户在同岗位用户中的排名
export const USER_ROLE_RANKING = {
  totalPeers: 286,
  loginDaysRank: 45,       // 登录天数排名
  loginDaysPercentile: 84, // 超过 84% 的同岗位用户
  reportsCreatedRank: 32,
  reportsCreatedPercentile: 89,
  reportsViewedRank: 28,
  reportsViewedPercentile: 90,
  activityLevel: '活跃',    // 活跃/一般/待提升
}

// 用户在机构中的排名
export const USER_DEPT_RANKING = {
  totalPeers: 48,
  loginDaysRank: 8,
  loginDaysPercentile: 83,
  reportsCreatedRank: 6,
  reportsCreatedPercentile: 88,
  reportsViewedRank: 5,
  reportsViewedPercentile: 90,
  activityLevel: '活跃',
}

// 用户在全行的排名
export const USER_BANK_RANKING = {
  totalPeers: 3256,
  loginDaysRank: 420,
  loginDaysPercentile: 87,
  reportsCreatedRank: 280,
  reportsCreatedPercentile: 91,
  reportsViewedRank: 310,
  reportsViewedPercentile: 90,
  activityLevel: '活跃',
}

// 建议操作
export const SUGGESTED_ACTIONS = [
  {
    id: 'action-1',
    title: '尝试使用透视分析功能',
    description: '您目前主要使用明细查询，透视分析可帮您更直观地发现数据规律。',
    priority: 'high',
    relatedTemplateId: '1',
    icon: '📊',
  },
  {
    id: 'action-2',
    title: '关注最新上线的代发客群主题',
    description: '与您工作相关的代发客群资金交易明细主题已上线，建议立即体验。',
    priority: 'high',
    relatedTemplateId: '11',
    icon: '🆕',
  },
  {
    id: 'action-3',
    title: '查看同岗位用户常用的报表模板',
    description: '发现同岗位用户经常使用的 3 个模板，您可以直接套用。',
    priority: 'medium',
    relatedTemplateId: undefined,
    icon: '👥',
  },
  {
    id: 'action-4',
    title: '学习经典案例：精准营销提升AUM',
    description: '该案例与您日常工作高度相关，学习后可提升营销效果。',
    priority: 'medium',
    relatedTemplateId: undefined,
    icon: '💡',
  },
]

// 推荐内容
export const RECOMMENDED_CONTENT = {
  templates: [
    { id: '1', name: '对公大额存款变动情况', department: '公司金融部', reason: '同岗位用户常用' },
    { id: '11', name: '代发客群营销分析', department: '零售金融部', reason: '与您工作相关' },
  ],
  topics: [
    { id: 'topic-payroll', name: '代发客群资金交易明细主题', department: '零售金融部', catalogId: 'retail-customer', reason: '最新上线' },
    { id: 'topic-corp-deposit', name: '对公大额存款变动情况', department: '公司金融部', catalogId: 'retail-deposit', reason: '同岗位热门' },
  ],
  cases: [
    { id: '1', name: '精准营销提升代发客群AUM', department: '零售金融部', reason: '高匹配度' },
    { id: '2', name: '对公客户资金链分析案例', department: '公司金融部', reason: '同岗位推荐' },
  ],
}

// 一键服务工单
export interface ServiceTicket {
  id: string
  question: string
  status: 'pending' | 'processing' | 'resolved'
  createdAt: string
  reply?: string
  repliedAt?: string
}

// 模拟已有工单数据
export const SERVICE_TICKETS: ServiceTicket[] = [
  {
    id: 'ticket-1',
    question: '如何导出透视分析报表为Excel格式？',
    status: 'resolved',
    createdAt: '2026-05-28 14:30',
    reply: '您好！在报表制作页面的顶部工具栏中，点击"导出"按钮即可选择导出为Excel格式。如仍有疑问，请随时联系我们。',
    repliedAt: '2026-05-29 09:15',
  },
  {
    id: 'ticket-2',
    question: '代发客群模板中如何筛选特定月份的代发数据？',
    status: 'resolved',
    createdAt: '2026-06-01 10:20',
    reply: '您好！在代发客群营销分析报表中，您可以使用筛选功能，选择"代发月份"字段并设置等于条件即可筛选指定月份数据。',
    repliedAt: '2026-06-01 16:45',
  },
]
